import { LinkButton } from '@/components/elements/forms/buttons';
import LIAccordion from '@/components/elements/lists/LIAccordion';
import PageViewLayout from '@/components/layouts/PageViewLayout/PageViewLayout';
import SEO, { seoPropsFromBaseString } from '@/components/modules/SEO';
import { SCREEN_NAME } from '@/constants/analytics';
import { GIFTCARD_PATH } from '@/constants/faq';
import GiftcardSelfServe from '@/features/giftcard-self-serve/GiftcardSelfServe';
import { url } from '@/helpers';
import { getSupportFaq } from '@/helpers/faq';
import useMobileView from '@/hooks/useMobileView';
import useTrackScreenShown from '@/hooks/useTrackScreenShown';
import { _t } from '@/locale/i18n';

const GiftcardsPage = () => {
  const giftCardFaq = getSupportFaq().find((section) => section.path === GIFTCARD_PATH);
  const { isMobileView } = useMobileView();
  useTrackScreenShown({ screen_name: SCREEN_NAME.CHECK_GIFTCARD });

  return (
    <PageViewLayout
      title=""
      type="mainView"
      wrapperClass={`min-h-screen bg-surface_mp`}
      source={'useGiftCard'}
      footerDisplayOption={{ from: 'md', to: 'all' }}>
      <div className={`flex flex-col justify-center ${isMobileView ? 'px-cv-padding py-xl' : 'py-[88px]'}`}>
        <div className={`gap-cv-margin flex justify-center ${isMobileView ? 'flex-col' : ''}`}>
          <section className={`flex flex-col ${isMobileView ? 'gap-cv-margin' : 'gap-cv-padding'}`}>
            <GiftcardSelfServe />
          </section>
          <section className={`gap-md flex flex-col ${isMobileView ? '' : 'w-[364px]'}`}>
            <h2 className="text-h-m">{_t('commonQuestions')}</h2>
            <>
              {giftCardFaq.questions.map((question, i) => {
                return (
                  <LIAccordion key={i} title={question.question} defaultOpen={false}>
                    <div dangerouslySetInnerHTML={{ __html: question.answer }}></div>
                    {(question.supportFormLinks || []).map((link, i) => {
                      return (
                        <LinkButton
                          key={i}
                          to={{
                            pathname: '/support/form',
                            state: { selectedSection: giftCardFaq.path, active: link.questionId },
                          }}
                          className="text-l mt-xs !px-0 underline">
                          {link.text}
                        </LinkButton>
                      );
                    })}
                  </LIAccordion>
                );
              })}
            </>
          </section>
        </div>
      </div>
      <SEO {...seoPropsFromBaseString('useGiftCard', url.getBaseUrl() + 'giftcards')} />
    </PageViewLayout>
  );
};

export default GiftcardsPage;
